import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

/** Utilities */
import { authentication } from "../../app/slice/authSlice";
import { createCookie, removeCookie } from "../../utils/Cookies/CookieHandler";

/** Common Components */
import Image from "../../components/image/Image";
import Buttons from "../../components/ui/button/Buttons";
// import Iconify from "../../components/ui/iconify/Iconify";
import Input from "../../components/ui/inputs/input/Input";

/** Common Services & Data Files */
import { AppIcons } from "../../data/appIcons";
import SwalAlert from "../../services/swalService/SwalService";
import ToastService from "../../services/toastService/ToastService";

/** RTK Query */
import { useAuthVerifyOTPMutation } from "../../app/services/authAPI";

/** CSS Files */
import "./TwoFactorAuthentication.scss";
import { encryptUrlData } from "../../services/CryptoService";

const TwoFactorAuthentication = () => {
  const inputRef = useRef();

  const dispath = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { error } = SwalAlert();

  let rememberMe = location?.state?.rememberMe;
  let pEmail_Address = location?.state?.user?.emailAddress;
  let UserId = location?.state?.user?.userId;
  let loginRememberMeDetails = rememberMe
    ? location?.state?.userLoginDetails
    : null;

  const [actualOtp, setActualOtp] = useState("");
  const [otpAttempts, setOtpAttempts] = useState(0);

  const maxattempts = 3;

  const [
    authVerifyOTP,
    {
      isLoading: isAuthVerifyOTPAdding,
      isSuccess: isAuthVerifyOTPAdded,
      data: authVerifyOTPData,
    },
  ] = useAuthVerifyOTPMutation();

  const handleChange = (e) => {
    let value = e.target.value;
    setActualOtp(value);
  };

  const handleSubmitClick = () => {
    let requestOtp = actualOtp;
    if (requestOtp && requestOtp.length === 6) {
      const req = {
        Otp: requestOtp,
        pEmail_Address: pEmail_Address,
        UserId: UserId,
      };
      authVerifyOTP(req);
    }
  };

  useEffect(() => {
    if (isAuthVerifyOTPAdded && authVerifyOTPData) {
      if (authVerifyOTPData?.isAuthenticated) {
        // Option A: pending reset stays on the public email reset page — no app session.
        if (authVerifyOTPData?.user?.isResetPassword) {
          removeCookie("rememberMe");
          ToastService.success(
            authVerifyOTPData.message || "Please set a new password."
          );
          navigate(
            `/ResetPassword/${encryptUrlData(authVerifyOTPData.user.userId)}`,
            {
              state: {
                temporaryPassword:
                  location?.state?.userLoginDetails?.password || "",
              },
            }
          );
          return;
        }

        dispath(authentication(authVerifyOTPData));

        if (rememberMe) {
          const rememberMeCookie = {
            cookieName: "rememberMe",
            cookieValue: loginRememberMeDetails,
            path: "/",
            expirationTime: 7 * 24,
          };
          createCookie(rememberMeCookie);
        } else {
          removeCookie("rememberMe");
        }

        navigate(`/Dashboard`);
        ToastService.success(authVerifyOTPData.message);
        setOtpAttempts(0);
      } else {
        const newAttempts = otpAttempts + 1;
        setOtpAttempts(newAttempts);

        if (newAttempts >= maxattempts) {
          error(
            "Too many failed attempts. Please Login again!",
            "Invalid OTP!"
          );
          removeCookie("rememberMe");
          navigate(`/login`);
        } else {
          error(
            `You have ${
              maxattempts - newAttempts
            } attempts left to verify OTP.`,
            `Invalid OTP!`
          );
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthVerifyOTPAdded, authVerifyOTPData]);

  return (
    <>
      <div className="login-main-section">
        <div className="login-container">
          <div className="login-content">
            <div className="login-background">
              <Image imagePath={AppIcons.LoginImg} altText="Login Vector" />
            </div>
            <div className="login-form-sec">
              <div className="center-form-section">
                <h1 className="logo-img">
                  <Image
                    imagePath={AppIcons.logoImage}
                    altText="Login Vector"
                  />
                </h1>
                {/* <h1 className="logo-text">Task Management</h1> */}
                <div className="login-form-desc">
                  <div className="card-title-main">
                    Two-Factor Authentication
                  </div>
                  <div className="card-sub-title">
                    Authentication code
                  </div>
                </div>
                <div className="login-form-part">
                  <Input
                    ref={inputRef}
                    maxLength={6}
                    placeholder="Please Enter Authentication Code"
                    onChange={handleChange}
                    type="password"
                  />
                </div>
                <Buttons
                  buttonText="Submit"
                  buttonTypeClassName="btn theme-btn w-full"
                  onClick={handleSubmitClick}
                  isLoading={isAuthVerifyOTPAdding}
                  isDisable={actualOtp.length < 6}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TwoFactorAuthentication;
